const doc = [({"ja":({"adminComponentHotelMail":({"hotelMailTitle":"メール設定", "informationTitle":"連絡事項", "arrangedInformationDescription":"施設様で予約確定した時のメールで表示されます"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;